export default {
  en: {
    'components.message-reply-form.body.validation.required': 'Message required',
    'components.message-reply-form.body.label': 'Message',
    'components.message-reply-form.body.placeholder': 'Type a message',

    'components.message-reply-form.send': 'Send',
    'components.message-reply-form.cancel': 'Cancel',
  },
};
